// Contact Form Message
document.addEventListener("DOMContentLoaded", function () {
  const msg = document.querySelector(".contact-success");
  if (msg) {
    setTimeout(() => {
      msg.classList.add("fade-out");
      setTimeout(() => msg.style.display = "none", 1000); // hide after fade-out
    }, 6000);
  }
});

// ////////////////quantity///////////////////////////////

//   document.addEventListener("DOMContentLoaded", function () {
//     document.querySelectorAll(".plus_minus").forEach((container) => {
//       const input = container.querySelector(".nums");
//       const buttons = container.querySelectorAll(".i_btn");

//       if (!input.value) input.value = "1";

//       buttons.forEach((btn, index) => {
//         btn.addEventListener("click", function () {
//           let qty = parseInt(input.value) || 1;
//           qty = index === 0 ? Math.max(1, qty - 1) : qty + 1;
//           input.value = qty < 10 ? "0" + qty : qty;
//         });
//       });
//     });


//     // document.querySelectorAll(".addToCartBtn").forEach((btn) => {
//     //   btn.addEventListener("click", function () {
//     //     const variantId = btn.dataset.variantId;

//     //     const qtyInput = btn.closest(".crt_crd").querySelector(".nums");
//     //     const quantity = parseInt(qtyInput.value) || 1;

//     //     fetch('/cart/add.js', {
//     //       method: 'POST',
//     //       headers: { 'Content-Type': 'application/json' },
//     //       body: JSON.stringify({
//     //         id: variantId,
//     //         quantity: quantity
//     //       })
//     //     })
//     //     .then(response => response.json())
//     //     .then(data => {
//     //       alert("Product added to cart successfully!");
//     //     })
//     //     .catch(error => {
//     //       alert("Error adding product to cart.");
//     //     });
//     //   });
//     // });


//     document.querySelectorAll(".addToCartBtn").forEach((btn) => {
//     btn.addEventListener("click", function (e) {
//       e.preventDefault();

//       const variantId = btn.dataset.variantId;
//       const productUrl = btn.dataset.productUrl;  // <-- get product URL

//       const qtyInput = btn.closest(".crt_crd").querySelector(".nums");
//       const quantity = parseInt(qtyInput.value) || 1;

//       fetch('/cart/add.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           id: variantId,
//           quantity: quantity
//         })
//       })
//       .then(res => res.json())
//       .then(data => {
//         // Redirect AFTER successful add
//         window.location.href = productUrl;
//       })
//       .catch(err => {
//         alert("Error adding product to cart.");
//       });
//     });
//   });


//     document.querySelectorAll(".buyNowBtn").forEach((btn) => {
//       btn.addEventListener("click", function () {
//         const variantId = btn.dataset.variantId;

//         const qtyInput = btn.closest(".crt_crd").querySelector(".nums");
//         const quantity = parseInt(qtyInput.value) || 1;

//         fetch('/cart/clear.js', { method: 'POST' }) // clear cart for buy-now
//         .then(() => {
//           return fetch('/cart/add.js', {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify({
//               id: variantId,
//               quantity: quantity
//             })
//           });
//         })
//         .then(() => {
//           window.location.href = "/checkout";  // redirect to checkout
//         })
//         .catch(error => {
//           alert("Error processing Buy Now.");
//         });
//       });
//     });

//   });
